import "./About.module.css";
import Header from "@/reusable_sections/Header";
import EditorialPageHeader from "./sections/EditorialPageHeader";
import AboutEditorial from "./sections/AboutEditorial";
import EditorialNarrative from "./sections/EditorialNarrative";
import Certifications from "./sections/Certifications";
import TrainersMinimalistList from "./sections/TrainersMinimalistList";
import MissionEditorial from "./sections/MissionEditorial";
import Imaginez from "./sections/Imaginez";
import PostpartumQuoteCTA from "./sections/PostpartumQuoteCTA";
import Footer from "@/reusable_sections/Footer";
export default function AboutPage() {
  return <div>
      <Header />
      <EditorialPageHeader />
      <AboutEditorial />
      <EditorialNarrative />
      <Certifications />
      <TrainersMinimalistList />
      <MissionEditorial />
      <Imaginez />
      <PostpartumQuoteCTA />
      <Footer />
    </div>;
}